import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";

interface ListSectionAccordionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

/**
 * Seção de listas da família — header fixo no mobile; accordion no desktop.
 */
export function ListSectionAccordion({
  title,
  subtitle,
  children,
  defaultExpanded = true,
}: ListSectionAccordionProps) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobileLayout) {
    return (
      <Box sx={{ mb: 2, width: "100%", maxWidth: "100%", minWidth: 0 }}>
        <Stack spacing={0.35} sx={{ mb: 1.25, px: 1.5 }}>
          <Typography
            variant="subtitle1"
            fontWeight={800}
            sx={{
              fontSize: "0.9375rem",
              letterSpacing: "-0.02em",
              lineHeight: 1.25,
            }}
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="caption" color="text.secondary" lineHeight={1.35}>
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
        {children}
      </Box>
    );
  }

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disableGutters
      sx={{
        border: "1px solid #ccc",
        boxShadow: "1px 1px 8px 1px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        mb: 2.5,
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary
        expandIcon={<GridExpandMoreIcon />}
        sx={{
          px: 2,
          minHeight: 56,
          "& .MuiAccordionSummary-content": { my: 1 },
        }}
      >
        <Stack spacing={0.25}>
          <Typography variant="h6">{title}</Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, pb: 2 }}>{children}</AccordionDetails>
    </Accordion>
  );
}
